import { useQuery } from "react-query";
import { getLeasedEquipment } from "../../../../actions/CarrierAgreementMgmt/LeasedEquipment";

export const useGetLeasedEquipment = () => {
  return useQuery("GetLeasedEquipment", getLeasedEquipment, {
    refetchOnWindowFocus: false,
  });
};
